import React from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Layers, ArrowDownAZ, ArrowUpAZ, RotateCcw } from "lucide-react";

/**
 * Controles compactos de agrupado + ordenado para listas.
 *
 * Props:
 *  - groupBy / setGroupBy: string ("none" = sin grupos)
 *  - groupOptions: [{ value, label, icon? }]
 *  - sortBy / setSortBy
 *  - sortOptions: [{ value, label }]
 *  - sortDir / setSortDir: "asc" | "desc"
 *  - onReset (optional): callback para limpiar también anchos de columnas / filtros
 *  - testIdPrefix: prefijo para data-testid
 */
export default function GroupSortControls({
  groupBy, setGroupBy, groupOptions = [],
  sortBy, setSortBy, sortOptions = [],
  sortDir, setSortDir,
  onReset,
  testIdPrefix = "list",
}) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {groupOptions.length > 0 && (
        <div className="flex items-center gap-1">
          <Layers className="w-3.5 h-3.5 text-zinc-500" />
          <Select value={groupBy} onValueChange={setGroupBy}>
            <SelectTrigger className="w-44 h-9 bg-zinc-900/70 border-zinc-800 text-xs"
              data-testid={`${testIdPrefix}-group-by`}>
              <SelectValue placeholder="Agrupar…" />
            </SelectTrigger>
            <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
              <SelectItem value="none">Sin agrupar</SelectItem>
              {groupOptions.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      {sortOptions.length > 0 && (
        <div className="flex items-center gap-1">
          <Select value={sortBy} onValueChange={setSortBy}>
            <SelectTrigger className="w-44 h-9 bg-zinc-900/70 border-zinc-800 text-xs"
              data-testid={`${testIdPrefix}-sort-by`}>
              <SelectValue placeholder="Ordenar…" />
            </SelectTrigger>
            <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
              {sortOptions.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <button type="button"
            onClick={() => setSortDir(sortDir === "asc" ? "desc" : "asc")}
            data-testid={`${testIdPrefix}-sort-dir`}
            title={sortDir === "asc" ? "Ascendente — click para descendente" : "Descendente — click para ascendente"}
            className="h-9 w-9 inline-flex items-center justify-center rounded-md bg-zinc-900/70 border border-zinc-800 hover:bg-zinc-800 text-zinc-300">
            {sortDir === "asc" ? <ArrowDownAZ className="w-4 h-4" /> : <ArrowUpAZ className="w-4 h-4" />}
          </button>
        </div>
      )}
      {onReset && (
        <Button variant="ghost" size="sm" onClick={onReset}
          data-testid={`${testIdPrefix}-reset-view`}
          className="h-9 text-xs text-zinc-400 hover:text-zinc-200">
          <RotateCcw className="w-3.5 h-3.5 mr-1" /> Reset vista
        </Button>
      )}
    </div>
  );
}
